import { View } from "react-native";

/**
 * View that shifts content up to make space for keyboard (when shown) on iOS.
 * 
 * This component has an iOS only override and is pretty much a stub for other platforms.
 */
export default View;
